import Bet1X2 from './Bet1x2.js';

/**
 * Bet class for Challenge.
 * Contains product specific logic for rowPriceMulti as today.
 */
class BetChallenge extends Bet1X2 {
  #rowPriceMulti = 1;

  override get rowPriceMulti(): number {
    return this.#rowPriceMulti;
  }

  setRowPriceMulti(rowPriceMulti: number): this {
    this.#rowPriceMulti = rowPriceMulti;
    return this;
  }
}

export default BetChallenge;
